import { render, staticRenderFns } from "./eLearning.vue?vue&type=template&id=c70a56d8&scoped=true&"
import script from "./eLearning.vue?vue&type=script&lang=js&"
export * from "./eLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70a56d8",
  null
  
)

export default component.exports